const url = process.env.VUE_APP_API_URL + "logout"

export default {
  namespaced: true,

  state: {
    logoutLoading: false
  },
  mutations: {
    setLogoutLoading (state, val) {
      state.logoutLoading = val
    }
  },

  actions: {
    async doLogout({ commit, rootState }) {
      commit("setLogoutLoading", true)

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })
        
        await response.json()
      } catch(error) {
        console.log(error)
      } finally {
        commit("setLogoutLoading", false)
      }

      // Reset all main states
      commit("resetStates", "", { root: true }) 

      commit("setUserData", null, { root: true })
      commit("setUserToken", {}, { root: true })
      commit("setAppData", null, { root: true })
      localStorage.removeItem("userToken")
    }
  }
}